<template>
  <v-row dense>
    <template v-for="n in 12">
      <v-col :key="n" cols="12" md="3">
        <v-card outlined rounded="lg" elevation="1">
          <v-card-text>
            <v-skeleton-loader type="list-item-avatar"></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>

<script>
export default {
  name: "user-skeleton-loaders",
};
</script>
